import React, { useContext } from "react";
// @ts-ignore
import Banner from "../../components/SatCourse/SatSubBanner";
import { BsChevronRight } from "react-icons/bs";
import { FiLock } from "react-icons/fi";
// @ts-ignore
import NavBar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface SatChapter {
  id: string | number;
  lockStatus: boolean;
  title: string;
  about: string;
  progressPercent: number;
  topicsCount: number;
}

export interface ChaptersProps {
  moduleId: string | number;
  isError: string | boolean;
  Error?: string;
  moduleIndex: number;
  isLoading?: boolean;
  HAndleIndex: (
    chaptersId: string | number,
    title: string,
    about: string,
    progressPercent: number,
    index: number
  ) => void;
}

const Chapters: React.FC<ChaptersProps> = (props) => {
  const { satCourseData, checkSatNavbar, satChapters } = useContext<any>(UserContext);

  return (
    <>
      <div className="Home-Container">
        {props.isError ? (
          <h1>{props?.Error}</h1>
        ) : (
          <div className="home-sub-container">
            {window.innerWidth < 1024 ? (
              <>{checkSatNavbar ? <NavBar /> : ""}</>
            ) : (
              <div className="cp-Navbar-container">
                <NavBar />
              </div>
            )}
            <div className="main-right-container">
              <>
                <div>
                  <Banner
                    title={satCourseData[0]?.modules[props?.moduleIndex]?.title}
                    progressPercent={
                      satCourseData[0]?.modules[props?.moduleIndex]
                        ?.progressPercent
                    }
                    chaptersCount={
                      satCourseData[0]?.modules[props?.moduleIndex]
                        ?.chaptersCount
                    }
                    about={satCourseData[0]?.modules[props?.moduleIndex]?.about}
                  />
                </div>
                <div className="List-panel">
                  <div>
                    {props.isLoading ? (
                      [1, 2, 3, 4, 5].map((key) => (
                        <div className="list-item-panel placeholder-glow" key={key}>
                          <div className="list-item-left-section w-100">
                            <div className="list-item-id-panel placeholder" style={{ width: 40, height: 40, borderRadius: 20 }}></div>
                            <div className="list-item-title-panel ms-3 w-100">
                              <span className="placeholder d-block col-6 mb-2" style={{ height: 20, borderRadius: 4 }}></span>
                              <span className="placeholder d-block col-4" style={{ height: 16, borderRadius: 4 }}></span>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      satChapters?.map((item: SatChapter, index: number) => {
                        return (
                        <div
                          className={
                            item.lockStatus
                              ? "list-item-panel disable-div "
                              : "list-item-panel"
                          }
                          key={item.id}
                          onClick={() => {
                            props.HAndleIndex(
                              item.id,
                              item.title,
                              item.about,
                              item.progressPercent,
                              index
                            );
                          }}
                        >
                          <div className="list-item-left-section">
                            <div
                              className={
                                item.lockStatus
                                  ? "list-item-id-panel list-icon-bg"
                                  : "list-item-id-panel"
                              }
                            >
                              {item.lockStatus ? (
                                <>
                                  <FiLock size="15px" color="#807f7f" />
                                </>
                              ) : (
                                <>{index + 1}</>
                              )}
                            </div>
                            <div className="list-item-title-panel">
                              <div
                                className={
                                  item.lockStatus
                                    ? "list-item-title-div l-t-disable"
                                    : "list-item-title-div"
                                }
                              >
                                <p>{item.title}</p>
                              </div>
                              <div className="list-item-lesson-panel">
                                <p>{`${item.topicsCount} topics`}</p>
                              </div>
                            </div>
                          </div>
                          <div className="list-item-icon-panel">
                            <BsChevronRight size="15px" />
                          </div>
                        </div>
                      );
                    })
                  )}
                  </div>
                </div>
              </>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(Chapters);
